// extracted by mini-css-extract-plugin
export default {"wrapper":"radio_wrapper__zDrF2","horizontal":"radio_horizontal__zlEjF","horizontal2":"radio_horizontal2__7HI-t","vertical":"radio_vertical__tD7BF"};